// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/grids/FunctionalitiesGrid/components/createUserModal/createFunctionalitiesModalStyles.css
// module id = 767
// module chunks = 1